import Vue from 'vue'
//import BootstrapVue from 'bootstrap-vue'
import {NavbarPlugin, LayoutPlugin, CardPlugin, TabsPlugin, ListGroupPlugin, ButtonPlugin} from 'bootstrap-vue'

Vue.use(LayoutPlugin)
Vue.use(NavbarPlugin)
Vue.use(CardPlugin)
Vue.use(TabsPlugin)
Vue.use(ListGroupPlugin)
Vue.use(ButtonPlugin)

import './utils/fontAwesome'

import App from './App.vue'
import store from './store'
import router from './router/router.js'

Vue.config.productionTip = false;
//Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.carmine.css';

import './sass/styles.scss'


import "devextreme-intl";
// Dictionaries for German and Russian languages
import ruMessages from "devextreme/localization/messages/ru.json";

import {locale, loadMessages} from "devextreme/localization";

loadMessages(ruMessages);
locale('ru');

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app');
